export interface Image {
  url: string;
  width: string;
  height: string;
}

export interface RichText {
  html: string;
  plaintext: string;
}

export interface Raffle {
  id: string;
  headline: string;
  description: {
    plaintext: string;
  };
  images: { main?: Image; secondary?: Image };
  participation?: { registration: string } | null;
  productRegistrationRequired: boolean;
  eligible: boolean;
  active: boolean;
  startDateOfRaffle: string;
  endDateOfRaffle: string;
  startDateOfPurchaseDate?: string;
  endDateOfPurchaseDate?: string;
  afterSubmissionResponse: RichText;
  termsAndConditions: RichText;
  privacyPolicy: RichText;
  questions?: RaffleParticipationQuestion[];
}

export enum AnswerFormat {
  Boolean = 'Boolean',
  Number = 'Number',
  SingleSelect = 'SingleSelect',
  Text = 'Text',
}

interface AnswerOption {
  label: string;
  value: string;
}

export interface RaffleParticipationQuestion {
  default?: string;
  id: string;
  options?: AnswerOption[];
  /** The text of the question to be displayed. */
  question: string;
  /** Indicates whether answering the question is required. */
  required: boolean;
  /** The expected answer format for this question. */
  type: AnswerFormat;
}

export enum VoucherStatus {
  Valid = 'Valid',
  Expired = 'Expired',
  Redeemed = 'Redeemed',
}

export interface Voucher {
  promotionId: string;
  promotionName: string;
  voucherCode: string;
  title: string;
  legalInformation?: string;
  images: { main?: Image };
  creationDate: string;
  expirationDate: string;
  status: VoucherStatus;
  callToActionURL: string;
}
